import { createContext, useContext } from 'react';
export const SettingsContext = /*#__PURE__*/createContext(null);
export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (context === null) {
    throw new Error('SettingsContext is null');
  }
  return context;
};
//# sourceMappingURL=SettingsProvider.js.map